/**
 * Tooltip system for Vue 3
 *
 * Uses tippy.js via a custom v-tooltip directive for hover tooltips.
 * Slot-based popovers are handled by the Popover UI component (reka-ui).
 */
import { tippyDirective } from './tippyDirective'

import './tooltip.scss'

export function initTooltip(app) {
  app.directive('tooltip', tippyDirective)
}
